import { render } from "./NotificationDropdown.vue?vue&type=template&id=4de2e4ed&scoped=true"
import script from "./NotificationDropdown.vue?vue&type=script&lang=js"
export * from "./NotificationDropdown.vue?vue&type=script&lang=js"

import "./NotificationDropdown.vue?vue&type=style&index=0&id=4de2e4ed&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4de2e4ed"

export default script